import React from "react";
import { Modal } from "react-bootstrap";

const ModalConfirmationDomain = (props) => {
  return (
    <>
      <Modal show={props.show} onHide={props.onHide} backdrop="static" centered>
        <Modal.Header closeButton>
          <Modal.Title>Lengkapi Nanti Domain Bersyarat</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Lengkapi Syarat Pendaftaran <strong>Paling Lambat 3x24 Jam</strong>{" "}
            Setelah Memesan Layanan.
          </p>
          neon
          <div className="row mt-5">
            <button
              className="btn btn-modal-login"
              type="submit"
              onClick={props.onClick}
            >
              OK
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ModalConfirmationDomain;
